var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 9,
    viewBox: "0 0 10 9",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58637 2.16743C2.72237 2.03143 2.94286 2.03143 3.07886 2.16743L4.92205 4.01062L6.76525 2.16743C6.90124 2.03143 7.12174 2.03143 7.25773 2.16743C7.39373 2.30342 7.39373 2.52392 7.25773 2.65991L5.41454 4.50311L7.25773 6.3463C7.39373 6.4823 7.39373 6.70279 7.25773 6.83879C7.12174 6.97478 6.90124 6.97478 6.76525 6.83879L4.92205 4.99559L3.07886 6.83879C2.94286 6.97478 2.72237 6.97478 2.58637 6.83879C2.45038 6.70279 2.45038 6.4823 2.58637 6.3463L4.42957 4.50311L2.58637 2.65991C2.45038 2.52392 2.45038 2.30342 2.58637 2.16743Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58637 2.16743C2.72237 2.03143 2.94286 2.03143 3.07886 2.16743L4.92205 4.01062L6.76525 2.16743C6.90124 2.03143 7.12174 2.03143 7.25773 2.16743C7.39373 2.30342 7.39373 2.52392 7.25773 2.65991L5.41454 4.50311L7.25773 6.3463C7.39373 6.4823 7.39373 6.70279 7.25773 6.83879C7.12174 6.97478 6.90124 6.97478 6.76525 6.83879L4.92205 4.99559L3.07886 6.83879C2.94286 6.97478 2.72237 6.97478 2.58637 6.83879C2.45038 6.70279 2.45038 6.4823 2.58637 6.3463L4.42957 4.50311L2.58637 2.65991C2.45038 2.52392 2.45038 2.30342 2.58637 2.16743Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.928639
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.062b615d1e75c14b4fc0c8c86765dd7d.svg";
export { ForwardRef as ReactComponent };